import { render } from "./PostActions.vue?vue&type=template&id=2b81b03f&scoped=true"
import script from "./PostActions.vue?vue&type=script&lang=js"
export * from "./PostActions.vue?vue&type=script&lang=js"

import "./PostActions.vue?vue&type=style&index=0&id=2b81b03f&lang=scss&scoped=true"

import exportComponent from "/app/src/client/.yarn/__virtual__/vue-loader-virtual-e12e5a5897/0/cache/vue-loader-npm-17.0.1-f552b82805-b10a7b05ba.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b81b03f"]])

export default __exports__